export default __webpack_public_path__ + "static/media/emotionDecH3.1f664e39.png";